import { createLoanCrudHooks } from './lib/create-crud-hooks';
import type { Caveat } from '@/types';

export interface CreateCaveatInput {
  companyName: string;
  propertyDescription: string;
  amount?: number;
  lodgedDate?: string;
  expiryDate?: string;
  state?: string;
  status?: string;
  reason?: string;
  notes?: string;
}

export interface UpdateCaveatInput {
  companyName?: string;
  propertyDescription?: string;
  amount?: number | null;
  lodgedDate?: string | null;
  expiryDate?: string | null;
  state?: string | null;
  status?: string;
  reason?: string | null;
  notes?: string | null;
}

const { useList, useCreate, useUpdate, useDelete } = createLoanCrudHooks<
  Caveat,
  CreateCaveatInput,
  UpdateCaveatInput
>('caveats', 'caveats');

export {
  useList as useCaveats,
  useCreate as useCreateCaveat,
  useUpdate as useUpdateCaveat,
  useDelete as useDeleteCaveat,
};
